var _path, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAgency1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_898_1267)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_898_1267",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 4,
    y: 4,
    width: 20,
    height: 20
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 4H4V24H24V4Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_898_1267)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.0103 8.89069C16.0103 11.5917 14.1487 13.7813 11.8526 13.7813C9.5565 13.7813 7.69502 11.5917 7.69496 8.89069C7.69496 6.18965 8.3061 4 11.8526 4C15.3989 4 16.0103 6.18965 16.0103 8.89069ZM14.1294 14.1566C18.9849 15.0053 19.6194 16.346 19.6964 21.0513C19.7013 21.3523 19.7039 21.4043 19.7053 21.3774C19.7051 21.4571 19.705 21.5745 19.705 21.7431C19.705 21.7431 18.5489 24 11.8527 24C5.15665 24 4.00063 21.7431 4.00063 21.7431C4.00063 21.4806 4.00025 21.3301 4 21.2487C4.00131 21.2922 4.00463 21.2726 4.01183 20.8984C4.10031 16.3169 4.77354 14.9959 9.57612 14.1566C9.57612 14.1566 10.2596 15 11.8527 15C13.4457 15 14.1294 14.1566 14.1294 14.1566ZM17.6224 12.9081C19.4873 12.9081 20.9991 11.1297 20.9991 8.93604C20.9991 6.74227 20.5028 4.9639 17.6224 4.9639C17.1379 4.9639 16.721 5.01438 16.3624 5.10863C17.0276 6.29639 17.1188 7.73907 17.1188 8.89065C17.1188 10.1945 16.7539 11.4394 16.0817 12.4701C16.5437 12.7495 17.0672 12.9081 17.6224 12.9081ZM19.4714 13.2128C23.415 13.9022 23.9303 14.9911 23.9928 18.8126C23.9967 19.0587 23.9989 19.0996 24 19.0768C23.9998 19.1416 23.9998 19.2364 23.9998 19.3746C23.9998 19.3746 23.456 20.4349 20.8029 20.9426C20.7577 18.4473 20.5387 16.7488 19.5866 15.4843C19.0359 14.7529 18.288 14.2531 17.4659 13.8941C17.5169 13.8964 17.5688 13.8979 17.6223 13.8979C18.9162 13.8979 19.4714 13.2128 19.4714 13.2128Z",
    fill: "#222939"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_898_1267"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(4 4)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAgency1);
export default __webpack_public_path__ + "static/media/agency-1.be1a0606678c98d6b0732ad31fcea82a.svg";
export { ForwardRef as ReactComponent };